import {defineLocale, LocaleData} from "ngx-bootstrap/chronos";
import {SUPPORTED_LANGUAGES} from "../languages";

export function initDatepickerLocales() {
  SUPPORTED_LANGUAGES
    .map(languageDefinition => (
      {
        ...languageDefinition,
        code: languageDefinition.code.toLowerCase()
      }
    ))
    .forEach(language => {
      defineLocale(language.code, buildLocaleData(language.code));
    });
}

export function buildLocaleData(code: string): LocaleData {
  const {firstDay, minimalDays} = weekInfoOf(code);
  const firstDayOfWeek = firstDay % 7;

  return {
    abbr: code,
    months: monthNames(code, "long"),
    monthsShort: monthNames(code, "short"),
    weekdays: weekdayNames(code, "long"),
    weekdaysShort: weekdayNames(code, "short"),
    weekdaysMin: weekdayNames(code, "narrow"),
    week: {
      dow: firstDayOfWeek,
      doy: 7 + firstDayOfWeek - minimalDays,
    },
  };
}

function monthNames(code: string, style: "long" | "short"): string[] {
  const formatter = new Intl.DateTimeFormat(code, {month: style, timeZone: "UTC"});

  return countFrom(12).map(month => formatter.format(new Date(Date.UTC(2021, month, 1))));
}

function weekdayNames(code: string, style: "long" | "short" | "narrow"): string[] {
  const formatter = new Intl.DateTimeFormat(code, {weekday: style, timeZone: "UTC"});

  return countFrom(7).map(dayOffset => formatter.format(new Date(Date.UTC(2021, 7, 1 + dayOffset))));
}

function weekInfoOf(code: string): { firstDay: number; minimalDays: number } {
  const locale = new Intl.Locale(code) as Intl.Locale & {
    weekInfo?: { firstDay: number; minimalDays: number };
    getWeekInfo?: () => { firstDay: number; minimalDays: number };
  };
  const info = locale.getWeekInfo ? locale.getWeekInfo() : locale.weekInfo;

  return {
    firstDay: info?.firstDay ?? 1,
    minimalDays: info?.minimalDays ?? 4,
  };
}

function countFrom(size: number): number[] {
  return [...Array(size).keys()];
}

export const dateTimeConfig = {
  inputFormat: "DD.MM.YYYY",
};
